import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store";
import { useGetECCalculateMutation } from "../../../services/EarningsCalculator/earningCalculatorAPI";
import { storedLocale } from "../../../components/Authentication/util";
import { updateCalculatedData } from "../../../reducers/earningCalculator";

export const useECCalculate = () => {
  const {
    EarningSummary: EarningSummaryBody,
    IncomeBreakdown: IncomeBreakdownBody,
    ABOLegs: ABOLegsBody,
    Settings: SettingsBody,
    Recalculate,
  } = useAppSelector((state: any) => state.earningCalculator);

  const dispatch = useAppDispatch();

  const [ecCalculate, { isLoading }] = useGetECCalculateMutation();
  const boot = useAppSelector(({ boot }: any) => boot);
  const { isoCountryCode = "" } = boot?.user || {};
  const { isoCurrencyCode = "" } = boot?.shellConfig || {};
  useEffect(() => {
    const timer = setTimeout(async () => {
      if (Recalculate === true) {
        try {
          const calculateAPIData = await ecCalculate({
            EarningSummary: EarningSummaryBody,
            IncomeBreakdown: IncomeBreakdownBody,
            ABOLegs: ABOLegsBody,
            Settings: SettingsBody,
            Locale: storedLocale(),
            ISOCurrencyCode: isoCurrencyCode,
            CountryCode: isoCountryCode,
          }).unwrap();
          dispatch(updateCalculatedData(calculateAPIData));
        } catch (error) {
          console.error("Failed to fetch EC Calculate:", error);
        }
      }
    }, 800);

    return () => clearTimeout(timer);
  }, [
    EarningSummaryBody,
    IncomeBreakdownBody,
    ABOLegsBody,
    SettingsBody,
    Recalculate,
    dispatch,
    ecCalculate,
    isoCountryCode,
    isoCurrencyCode,
  ]);
  return { isLoading };
};
